import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { CartImpressionTrackingInfo } from "@services/tracking/types/trackingInfo/cartImpressionTrackingInfo";
import { CartProductTrackingInfo } from "@services/tracking/types/trackingInfo/cartProductTrackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo,
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct,
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsCartCommerce {
    id?: string;
    revenue?: number;
    discount?: number;
    coupon?: string;
    item: GoogleAnalyticsProduct[];
}

export interface GoogleAnalyticsCartImpression
    extends GoogleAnalyticsMinimumDataset {
    commerce: GoogleAnalyticsCartCommerce;
    info: {
        name: string;
    };
}

const getGoogleAnalyticsCartImpression = (
    data: TypedAnalyticsEvent<CartImpressionTrackingInfo>,
): GoogleAnalyticsCartImpression => {
    return {
        event: GoogleAnalyticsEvents.ProductCartView,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            name: data.payload.eventData.name,
        },
        commerce: {
            revenue: data.payload.eventData.totalPrice,
            item: (data.payload.eventData.items || []).map(
                (item: CartProductTrackingInfo) => {
                    return {
                        ...getGoogleAnalyticsProduct(item),
                        quantity: item.quantity,
                    };
                },
            ),
        },
    };
};

export { getGoogleAnalyticsCartImpression };
